import Vue from 'vue'
import axios from '@/utils/axios.js'
import {
	getUrlParam
} from '@/utils/util.js'
import api from '@/api/api.js'
import {
	message
} from 'ant-design-vue'

/**
 * 单点登录
 */
const init = (callback) => {
	if (getUrlParam('auth_code') || getUrlParam('code')) {
		let auth_code = getUrlParam('auth_code')
		let state = getUrlParam('state')
		let appid = getUrlParam('appid')
		let code = getUrlParam('code')
		let data = {}
		auth_code && (data.auth_code = auth_code)
		state && (data.state = state)
		appid && (data.appid = appid)
		code && (data.code = code)
		validateSt(data, callback)
	} else {
		callback && callback()
	}
}
const SSO = {
	init: init,
}

function validateSt(data, callback) {
	axios.get(api.qywxLogin, {
			params: data,
		})
		.then((res) => {
			if (res.success) {
				let {
					token,
					userInfo
				} = res.result;
				message.success(res.message);
				Vue.prototype.$store.commit('SET_TOKEN', token);
				
				// 存储用户信息
				if (userInfo) {
					// Platform返回的是 customerName 和 customerPhone
					let userNameStr = userInfo.customerName || userInfo.customerPhone || userInfo.realname || userInfo.username || '管理员';
					localStorage.setItem("userName", userNameStr);
					localStorage.setItem("userId", userInfo.id);
				}

				location.href = `${process.env.VUE_APP_HOME_BASE_URL}?token=${encodeURIComponent(token)}`;
			}
		})
		.catch((err) => {})
	loginSuccess(callback)
}

function loginSuccess(callback) {
	callback()
}
export default SSO
